const UNSPLASH_API_URL = 'https://api.unsplash.com';
const ACCESS_KEY = process.env.NEXT_PUBLIC_UNSPLASH_ACCESS_KEY;

const END_POINT = process.env.NEXT_PUBLIC_BASE_URL;

export const getPhoto = ({
  perPage,
  page,
  query,
  orientation,
}: {
  perPage: number;
  page: number;
  query: string;
  orientation: 'landscape' | 'portrait' | 'squarish';
}) => {
  return fetch(
    `${UNSPLASH_API_URL}/search/photos?client_id=${ACCESS_KEY}&page=${page}&per_page=${perPage}&query=${encodeURIComponent(
      query
    )}&orientation=${orientation}&content_filter=high`
  );
};

export const downloadTrainingData = () => {
  return fetch(`${END_POINT}/internal/download`, {
    method: 'GET',
    credentials: 'include',
  });
};
